import z from "zod";
import { worksites } from "../../../attendances";

export const getAcknowledgementDefinitionsQuerySchema = z
	.object({
		worksite: z.enum(worksites),
		state: z.enum(["active", "inactive"]).optional(),
		projectId: z.uuid().optional(),
	})
	.superRefine((values, ctx) => {
		if (values.projectId && values.worksite !== "project-site") {
			ctx.addIssue({
				code: "custom",
				message: 'worksite must be "project-site" when projectId is assigned',
				path: ["worksite"],
			});
		}
	});

export type GetAcknowledgementDefinitionsQuerySchema = z.infer<
	typeof getAcknowledgementDefinitionsQuerySchema
>;
